import { isFieldError } from "../helpers";

import Select from "../components/Select";

const InviteDonateFields = ({
	handleUpdate,
	errors,
	golfTeamsRemaining,
	sportingTeamsRemaining,
}) => {
	return (
		<>
			<h4
				style={{
					marginTop: "0",
					lineHeight: "22px",
					marginBottom: "0",
					fontSize: "1.1rem",
				}}
			>
				Opt out an entire 4 spots for a team
			</h4>

			<table className="approved assigned" style={{ marginTop: "15px" }}>
				<thead>
					<tr>
						<th style={{ width: "50%" }}>Golf</th>
						<th style={{ width: "50%" }}>Sporting Clays</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td
							style={{ width: "50%" }}
						>{`${golfTeamsRemaining} team(s) remaining`}</td>
						<td
							style={{ width: "50%" }}
						>{`${sportingTeamsRemaining} team(s) remaining`}</td>
					</tr>
				</tbody>
			</table>

			<div className="form-group">
				<Select
					name="team"
					label="Select Team"
					reqd={true}
					value={""}
					options={[{ id: "", name: "--" }].concat(
						[
							{ id: "golf", name: "Golf" },
							{ id: "sporting", name: "Sporting Clays" },
						].filter(
							(item) =>
								(item.id === "golf" && golfTeamsRemaining > 0) ||
								(item.id === "sporting" && sportingTeamsRemaining > 0)
						)
					)}
					update={handleUpdate}
					error={isFieldError(errors, "team")}
				/>
				<div className="empty" />
			</div>
		</>
	);
};

export default InviteDonateFields;
